import { theme } from '@approvalmax/theme';
import SignUpConsentPopup from 'modules/first-start/containers/SignUpConsentPopup/SignUpConsentPopup';
import styled from 'styled-components';

/**
 * @deprecated Use Redesigned version
 */
export const PageContent = styled.div`
    background: #fff;
    border-radius: 8px;
`;

/**
 * @deprecated Use Redesigned version
 */
export const StyledSignUpConsentPopup = styled(SignUpConsentPopup)`
    width: 320px;
    margin: 40px 90px;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        width: 100%;
        padding: 40px 20px;
        margin: 0;
    }
`;
